/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Alert severity level
 */
export enum AlertSeverity {

    Info = 'info',

    Warning = 'warning',

    Error = 'error',

    Critical = 'critical'
}
